import styles from './ChatLockedBar.module.scss'
import { ReactComponent as LockIcon } from './lock.svg'

const ChatLockedBar = ({ children, color }) => {
  return (
    <div className={styles.bar} style={{ backgroundColor: color || '#8990a1' }}>
      <LockIcon />
      {children}
    </div>
  )
}

export default ChatLockedBar
